import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const StyledShipToContainer = styled.div`
  padding: ${token('space.0')};
  overflow-y: auto;
  .pane-sidebar-content {
    padding: ${token('space.0')} !important;

    > form {
      > div {
        padding: ${token('space.300')};
        padding-top: ${token('space.0')};
        > div > div {
          margin-top: 20px;
        }
        .currency-warning {
          margin-top: ${token('space.100')};
        }
      }
    }

    .form-footer {
      position: sticky;
      bottom: ${token('space.0')};
      background-color: ${token('elevation.surface')};
      padding: ${token('space.300')};
      margin-top: ${token('space.0')};
    }
  }
`;

export const StyledBillingProfileContainer = styled.div`
  overflow-y: hidden;
  height: 100%;
  .create-billing-profile-form {
    height: 100%;
    > div {
      height: 100%;
      > div {
        margin-top: ${token('space.0')};
      }
    }
  }
`;

export const CreateCustomerStyledHeader = styled.div`
  padding: ${token('space.0')} ${token('space.300')};
`;

export const StyledCompanyName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin-top: ${token('space.200')};
  > form {
    justify-content: space-between;
    >div: nth-child(1) {
      padding-inline: ${token('space.250')};
    }
    #footer {
      padding: ${token('space.300')};
    }
  }
`;
